import apiService from './apiService';

class FolderService {
  // Rules book Folder Management
  async createFolder(folderConfig) {
    try {
      // Extract processing options from the nested structure
      const processingOptions = folderConfig.processingOptions || {};
      
      // Transform the config to match API structure
      const apiPayload = {
        name: folderConfig.name,
        description: folderConfig.description,
        vectorStore: folderConfig.vectorStore || 'PGVector',
        embeddingModel: folderConfig.embeddingModel || 'text-embedding-3-large',
        useBatchMode: folderConfig.useBatchMode !== undefined ? folderConfig.useBatchMode : true,
        processingOptions: {
          chunkingStrategy: processingOptions.chunkingStrategy || 'semantic',
          dataSize: processingOptions.dataSize || 'medium',
          chunkSize: processingOptions.chunkSize || 1000,
          overlap: processingOptions.overlap || 200,
          similarityThreshold: processingOptions.similarityThreshold || 0.5,
          agenticModel: processingOptions.agenticModel || 'gpt-4o-mini',
          maxChunkSize: processingOptions.maxChunkSize || 2000,
          splitOnPages: processingOptions.splitOnPages !== undefined ? processingOptions.splitOnPages : true,
          skipHeader: processingOptions.skipHeader !== undefined ? processingOptions.skipHeader : false,
          cleanRows: processingOptions.cleanRows !== undefined ? processingOptions.cleanRows : true,
          searchType: processingOptions.searchType || 'hybrid'
        }
      };

      console.log('Sending folder config to API:', apiPayload);
      const result = await apiService.createKnowledgeBaseFolder(apiPayload);
      return result;
    } catch (error) {
      console.error('Error creating knowledge base folder:', error);
      throw error;
    }
  }

  async getFolders(knowledgeBaseType = null) {
    try {
      // Check if this is a D3 knowledge base request
      if (knowledgeBaseType === 'd3_knowledge_base') {
        const result = await apiService.getKnowledgeBaseFoldersD3();
        return result;
      }
      
      // Default to regular knowledge base folders
      const result = await apiService.getKnowledgeBaseFolders();
      return result;
    } catch (error) {
      console.error('Error fetching knowledge base folders:', error);
      throw error;
    }
  }

  async getFolder(folderId) {
    try {
      const result = await apiService.getKnowledgeBaseFolder(folderId);
      return result;
    } catch (error) {
      console.error('Error fetching knowledge base folder:', error);
      throw error;
    }
  }

  async getFolderWithFiles(folderId) {
    try {
      const result = await apiService.getKnowledgeBaseFolderWithFiles(folderId);
      return result;
    } catch (error) {
      console.error('Error fetching folder with files:', error);
      throw error;
    }
  }

  async getFolderConfiguration(folderId) {
    try {
      const result = await apiService.getKnowledgeBaseFolderConfiguration(folderId);
      return result;
    } catch (error) {
      console.error('Error fetching folder configuration:', error);
      throw error;
    }
  }

  async updateFolder(folderId, folderConfig) {
    try {
      // Extract processing options from the nested structure
      const processingOptions = folderConfig.processingOptions || {};
      
      // Transform the config to match API structure
      const apiPayload = {
        name: folderConfig.name,
        description: folderConfig.description,
        processingOptions: {
          chunkingStrategy: processingOptions.chunkingStrategy || 'semantic',
          dataSize: processingOptions.dataSize || 'medium',
          chunkSize: processingOptions.chunkSize || 1000,
          overlap: processingOptions.overlap || 200,
          similarityThreshold: processingOptions.similarityThreshold || 0.5,
          agenticModel: processingOptions.agenticModel || 'gpt-4o-mini',
          maxChunkSize: processingOptions.maxChunkSize || 2000,
          splitOnPages: processingOptions.splitOnPages !== undefined ? processingOptions.splitOnPages : true,
          skipHeader: processingOptions.skipHeader !== undefined ? processingOptions.skipHeader : false,
          cleanRows: processingOptions.cleanRows !== undefined ? processingOptions.cleanRows : true,
          searchType: processingOptions.searchType || 'hybrid'
        }
      };

      console.log('Sending update config to API:', apiPayload);
      const result = await apiService.updateKnowledgeBaseFolder(folderId, apiPayload);
      return result;
    } catch (error) {
      console.error('Error updating knowledge base folder:', error);
      throw error;
    }
  }

  async deleteFolder(folderId) {
    try {
      const result = await apiService.deleteKnowledgeBaseFolder(folderId);
      return result;
    } catch (error) {
      console.error('Error deleting knowledge base folder:', error);
      throw error;
    }
  }

  // Customer Data Folder Management
  async createFolderD3(folderConfig) {
    try {
      // Extract processing options from the nested structure
      const processingOptions = folderConfig.processingOptions || {};
      
      // Transform the config to match API structure
      const apiPayload = {
        name: folderConfig.name,
        description: folderConfig.description,
        vectorStore: folderConfig.vectorStore || 'PGVector',
        embeddingModel: folderConfig.embeddingModel || 'text-embedding-3-large',
        useBatchMode: folderConfig.useBatchMode !== undefined ? folderConfig.useBatchMode : true,
        processingOptions: {
          chunkingStrategy: processingOptions.chunkingStrategy || 'semantic',
          dataSize: processingOptions.dataSize || 'medium',
          chunkSize: processingOptions.chunkSize || 1000,
          overlap: processingOptions.overlap || 200,
          similarityThreshold: processingOptions.similarityThreshold || 0.5,
          agenticModel: processingOptions.agenticModel || 'gpt-4o-mini',
          maxChunkSize: processingOptions.maxChunkSize || 2000,
          splitOnPages: processingOptions.splitOnPages !== undefined ? processingOptions.splitOnPages : true,
          skipHeader: processingOptions.skipHeader !== undefined ? processingOptions.skipHeader : false,
          cleanRows: processingOptions.cleanRows !== undefined ? processingOptions.cleanRows : true,
          searchType: processingOptions.searchType || 'hybrid'
        }
      };

      console.log('Sending D3 folder config to API:', apiPayload);
      const result = await apiService.createKnowledgeBaseFolderD3(apiPayload);
      return result;
    } catch (error) {
      console.error('Error creating D3 knowledge base folder:', error);
      throw error;
    }
  }

  async getFoldersD3() {
    try {
      const result = await apiService.getKnowledgeBaseFoldersD3();
      return result;
    } catch (error) {
      console.error('Error fetching D3 knowledge base folders:', error);
      throw error;
    }
  }

  async getFolderD3(folderId) {
    try {
      const result = await apiService.getKnowledgeBaseFolderD3(folderId);
      return result;
    } catch (error) {
      console.error('Error fetching D3 knowledge base folder:', error);
      throw error;
    }
  }

  async getFolderWithFilesD3(folderId) {
    try {
      const result = await apiService.getKnowledgeBaseFolderWithFilesD3(folderId);
      return result;
    } catch (error) {
      console.error('Error fetching D3 folder with files:', error);
      throw error;
    }
  }

  async getFolderConfigurationD3(folderId) {
    try {
      const result = await apiService.getKnowledgeBaseFolderConfigurationD3(folderId);
      return result;
    } catch (error) {
      console.error('Error fetching D3 folder configuration:', error);
      throw error;
    }
  }

  async updateFolderD3(folderId, folderConfig) {
    try {
      // Extract processing options from the nested structure
      const processingOptions = folderConfig.processingOptions || {};
      
      // Transform the config to match API structure
      const apiPayload = {
        name: folderConfig.name,
        description: folderConfig.description,
        processingOptions: {
          chunkingStrategy: processingOptions.chunkingStrategy || 'semantic',
          dataSize: processingOptions.dataSize || 'medium',
          chunkSize: processingOptions.chunkSize || 1000,
          overlap: processingOptions.overlap || 200,
          similarityThreshold: processingOptions.similarityThreshold || 0.5,
          agenticModel: processingOptions.agenticModel || 'gpt-4o-mini',
          maxChunkSize: processingOptions.maxChunkSize || 2000,
          splitOnPages: processingOptions.splitOnPages !== undefined ? processingOptions.splitOnPages : true,
          skipHeader: processingOptions.skipHeader !== undefined ? processingOptions.skipHeader : false,
          cleanRows: processingOptions.cleanRows !== undefined ? processingOptions.cleanRows : true,
          searchType: processingOptions.searchType || 'hybrid'
        }
      };

      console.log('Sending D3 update config to API:', apiPayload);
      const result = await apiService.updateKnowledgeBaseFolderD3(folderId, apiPayload);
      return result;
    } catch (error) {
      console.error('Error updating D3 knowledge base folder:', error);
      throw error;
    }
  }

  async deleteFolderD3(folderId) {
    try {
      const result = await apiService.deleteKnowledgeBaseFolderD3(folderId);
      return result;
    } catch (error) {
      console.error('Error deleting D3 knowledge base folder:', error);
      throw error;
    }
  }

  // Auto-detect tags for folder naming
  autoDetectTags(fileName) {
    const name = fileName.toLowerCase();
    
    // Define tag patterns
    const tagPatterns = {
      'SOP': ['sop', 'standard', 'procedure', 'policy'],
      'POLICY': ['policy', 'policies', 'guideline', 'guidelines'],
      'BP': ['best', 'practice', 'bp', 'template'],
      'TEMPLATE': ['template', 'templates', 'form', 'forms'],
      'ADV': ['advice', 'advisory', 'recommendation', 'guide'],
      'TRAINING': ['training', 'tutorial', 'course', 'learning'],
      'CALL_LOG': ['call', 'log', 'transcript', 'recording'],
      'ORG': ['org', 'organization', 'company', 'corporate'],
      'TRADE_SECRET': ['secret', 'confidential', 'proprietary', 'internal'],
      'DELIVERY': ['delivery', 'shipping', 'logistics', 'fulfillment'],
      'PERSONA': ['persona', 'profile', 'customer', 'user'],
      'TP': ['tp', 'third', 'party', 'external'],
      'TLD': ['tld', 'top', 'level', 'domain'],
      'NICHE': ['niche', 'specialized', 'expert', 'technical'],
      'DNS': ['dns', 'domain', 'name', 'system']
    };

    // Find matching patterns
    const matchedTags = [];
    for (const [tag, patterns] of Object.entries(tagPatterns)) {
      if (patterns.some(pattern => name.includes(pattern))) {
        matchedTags.push(tag);
      }
    }

    // Return primary and secondary tags
    return {
      primaryTag: matchedTags[0] || null,
      secondaryTags: matchedTags.slice(1)
    };
  }
}

const folderService = new FolderService();
export default folderService;
